<template>
  <li><slot></slot></li>
</template>
<script type="text/ecmascript-6">
  export default {
    name: 'mcBaseListFoldItem'
  }
</script>



// WEBPACK FOOTER //
// src/components/base-list-fold-item.vue